import React, { useState, useEffect } from 'react'
import { Grid, Typography, Avatar, IconButton } from '@mui/material'
import format from 'date-fns/format'
import CloseIcon from '@mui/icons-material/Close'
import EditIcon from '@mui/icons-material/Edit'
import { useConfirm } from 'material-ui-confirm'
import EditReview from './EditReview'
import { Cloudinary } from '@cloudinary/url-gen'
import { Rating } from '@mui/material';

const ReviewItem = ({ review, updateReviewById, deleteReview, user }) => {
  const [studentAvatar, setStudentAvatar] = useState('')
  const [openDialog, setOpenDialog] = useState(false)

  const confirm = useConfirm()

  const handleCloseDialog = () => {
    setOpenDialog(false)
  }

  const handleOpenDialog = () => {
    setOpenDialog(true)
  }

  const handleDelete = () => {
    confirm({
      description: 'Nhấn đồng ý sẽ xóa nhận xét',
      title: 'Bạn có chắc không?',
    })
      .then(() => {
        deleteReview(review._id)
      })
      .catch(() => { })
  }

  useEffect(() => {
    const cld = new Cloudinary({
      cloud: {
        cloudName: 'youspeak',
      },
    })

    if (review && review.studentAvatar && !studentAvatar) {
      const cldRes = cld.image(review.studentAvatar)
      setStudentAvatar(cldRes.toURL())
    }
  }, [review, studentAvatar])

  return (
    <Grid container direction="column" justifyContent="center" alignItems="center">
      <Grid
        item
        container
        justifyContent="space-between"
        alignItems="center"
        style={{ width: '100%' }}
      >

        {review.rating && <Grid item>
          <Rating readOnly value={review.rating} precision={0.5} />
        </Grid>}

        {user._id === review.student ? (
          <Grid item style={{ alignSelf: 'flex-end' }}>
            <Grid container>
              <Grid item>
                <IconButton onClick={handleOpenDialog} size="large">
                  <EditIcon fontSize="small" />
                </IconButton>
              </Grid>
              <Grid item>
                <IconButton onClick={handleDelete} size="large">
                  <CloseIcon fontSize="small" />
                </IconButton>
              </Grid>
            </Grid>
          </Grid>
        ) : (
          <span>{''}</span>
        )}

        <EditReview
          openDialog={openDialog}
          setOpenDialog={setOpenDialog}
          handleCloseDialog={handleCloseDialog}
          review={review}
          updateReviewById={updateReviewById}
        />
      </Grid>

      <Grid item>
        <Typography variant="body1">{review.content}</Typography>
      </Grid>

      <Grid item container justifyContent="space-between" alignItems="center">
        <Grid item>
          <Grid container alignItems="center">
            <Grid item>
              <Avatar src={studentAvatar} />
            </Grid>
            <Grid item>&nbsp;{review.studentName}</Grid>
          </Grid>
        </Grid>

        <Grid item>
          <Grid container>
            <Grid item style={{ marginRight: '0.5em' }}>
              {review.isUpdated && (
                <Typography variant="body2">Đã sửa lại lần cuối lúc</Typography>
              )}
            </Grid>

            <Grid item>
              {format(new Date(review.date), 'hh:mm aa, dd-MM-yyyy')}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default ReviewItem
